import { render } from "./appendix.vue?vue&type=template&id=0da2f67f&scoped=true"
import script from "./appendix.vue?vue&type=script&lang=js"
export * from "./appendix.vue?vue&type=script&lang=js"

import "./appendix.vue?vue&type=style&index=0&id=0da2f67f&scoped=true&lang=css"
import "./appendix.vue?vue&type=style&index=1&id=0da2f67f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da2f67f"]])

export default __exports__